export const bills = '/bills';
export const bill = (id: number) => `/bills/${id}`;
export const download = 'bills/admin/download';
export const createBillTransaction = '/bill-transaction';
